module.exports = __webpack_public_path__ + "img/icon-item-dried-flower.e7bbb7ee.svg";